import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNotNilErrorMessage = (
  <Trans>
    Ce champ devrrait être vide
  </Trans>
);
